import React, { ButtonHTMLAttributes, ReactNode, ElementType } from 'react';

import { TabItem, TabsContainer, Caption, TabItemWrapper } from './styles';
import { SizeType as TypographySizeType } from '../../helpers';
import { Media } from '../../types';

export const propAlignItems = ['baseline', 'flex-end'] as const;
export type PropAlignItems = typeof propAlignItems[number];

interface TabsProps {
  children: ReactNode;
  size?: TypographySizeType | Media<TypographySizeType>;
  gap?: number | Media<number>;
  alignItems?: PropAlignItems;
  caps?: boolean;
  testId?: string;
}

export interface ItemProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  as?: ElementType;
  to?: string;
  isActive?: boolean;
  isDisabled?: boolean;
  caption?: JSX.Element;
}

export function Tabs(props: TabsProps) {
  const { size = 'L', gap = 25, alignItems = 'flex-end', ...other } = props;

  return (
    <TabsContainer role="tablist" size={size} gap={gap} alignItems={alignItems} {...other}>
      {props.children}
    </TabsContainer>
  );
}

Tabs.Item = (props: ItemProps) => {
  const { children, ...other } = props;

  const defineType = (): ButtonHTMLAttributes<HTMLButtonElement>['type'] => {
    if ((!props.to && !props.as) || props.as === 'button') return 'button';
    return undefined;
  };

  return (
    <TabItem type={defineType()} role="tab" aria-selected={props.isActive} {...other}>
      <TabItemWrapper>{children}</TabItemWrapper>
      {props.caption}
    </TabItem>
  );
};

Tabs.Caption = Caption;
